import { RelationshipToInsured } from "@api/operations.generated";

export const mapRelationshipToInsured = (
  value: RelationshipToInsured | string
): string => {
  switch (value) {
    case RelationshipToInsured.Policyholder:
      return "Policyholder";
    case RelationshipToInsured.Spouse:
      return "Spouse";
    case RelationshipToInsured.FamilyMember:
      return "Family Member";
    case RelationshipToInsured.Child:
      return "Child";
    case RelationshipToInsured.SecondOwner:
      return "Second Owner";
    case RelationshipToInsured.Other:
      return "Other";
    default:
      return "";
  }
};
